// extracted by mini-css-extract-plugin
export default {"PaginationParent":"AmpPagination_PaginationParent__yi+kH","FooterDiv":"AmpPagination_FooterDiv__sduMn"};